import { ReactNode } from 'react'
import { Link } from '@opengovsg/design-system-react'
import LinkifyReact from 'linkify-react'

// This function creates the desired Link components, based on the Chakra-UI `Link`
// Customize as needed!
export const Linkify = ({ children }: { children: ReactNode }) => {
  return (
    <LinkifyReact
      options={{
        render: ({ attributes, content }) => (
          <Link {...attributes} isExternal={true}>
            {content}
          </Link>
        ),
      }}
    >
      {children}
    </LinkifyReact>
  )
}
